"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Icons from font-awesome. Names can be found [here](http://fontawesome.io/icons/).
 */

const OriginalIcon = ({ className = "", name }) => {
  const iconStyle = `fa-${name}`;

  return _react2.default.createElement("i", { className: `fa ${iconStyle} ${className}` });
};

// This is for consistency, that way our final export will render a styled-component

const StyledIcon = (0, _styledComponents2.default)(OriginalIcon).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-11p0jl-0"
})([""]);

const Icon = (_ref) => {
  let props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(StyledIcon, props);
};

Icon.propTypes = {
  className: _propTypes2.default.string,

  /**
   * Name of icon
   */
  name: _propTypes2.default.string.isRequired
};

exports.default = Icon;